import React from "react";
import Header from "../../components/header/Header";
import { FaReact } from "react-icons/fa";
import { AiFillHtml5 } from "react-icons/ai";
import { SiMaterialui, SiTailwindcss, SiRedux } from "react-icons/si";
import { DiCss3 } from "react-icons/di";
import { BsBootstrapFill } from "react-icons/bs";
import { IoLogoNodejs } from "react-icons/io";
import SkillCard from "../../components/skills-card/SkillCard";

const Skills = () => {
    return (
        <div className="my-12" id="skills">
            <Header text="Skills"></Header>
            <div className="mx-12 grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-4 gap-2">
                <SkillCard icon={<FaReact color="#82F9A1" size="2.8rem" />} title="React" loader={89} number="8+" />
                <SkillCard icon={<AiFillHtml5 color="#82F9A1" size="2.8rem" />} title="HTML5" loader={95} number="4+" />
                <SkillCard icon={<DiCss3 color="#82F9A1" size="2.8rem" />} title="CSS3" loader={90} number="3+" />
                <SkillCard
                    icon={<SiMaterialui color="#82F9A1" size="2.8rem" />}
                    title="Material Ui"
                    loader={70}
                    number="5+"
                />
                <SkillCard
                    icon={<SiTailwindcss color="#82F9A1" size="2.8rem" />}
                    title="Tailwind Css"
                    loader={80}
                    number="6+"
                />
                <SkillCard
                    icon={<BsBootstrapFill color="#82F9A1" size="2.8rem" />}
                    title="Bootstrap"
                    loader={80}
                    number="3+"
                />
                <SkillCard icon={<SiRedux color="#82F9A1" size="2.8rem" />} title="Redux" loader={85} number="4+" />
                <SkillCard
                    icon={<IoLogoNodejs color="#82F9A1" size="2.8rem" />}
                    title="Nodejs"
                    loader={60}
                    number="2+"
                />
            </div>
        </div>
    );
};

export default Skills;
